<div class="confirm-overlay" *ngIf="showConfirmDialog" (click)="cancelDeleteFn()">
  <div class="confirm-card" (click)="$event.stopPropagation()">
    <div class="confirm-icon-wrap">
      <mat-icon class="confirm-trash-icon">delete_outline</mat-icon>
    </div>
    <h3 class="confirm-title">¿Eliminar archivo?</h3>
    <p class="confirm-subtitle">{{ fileTitle }}</p>
    <p class="confirm-warning">Esta acción no se puede deshacer.</p>
    <div class="confirm-actions">
      <button mat-stroked-button class="confirm-btn-cancel" (click)="cancelDeleteFn()">Cancelar</button>
      <button mat-flat-button class="confirm-btn-delete" (click)="confirmDeleteFn()">Eliminar</button>
    </div>
  </div>
</div>

<div class="h-100 position-relative">
  <div>
    <!-- Solo para STL: "pantalla completa" abre el visor de modelos 3D, que no
         sabe mostrar PDFs ni ZIPs. En esos archivos el botón no llevaba a nada. -->
    <mat-icon (click)="openFullScreen()" class="fullscreen-icon" *ngIf="fileSelected && isStlFile" matTooltip="Ver en pantalla completa" matTooltipPosition="below" style="z-index: 15;">open_in_new</mat-icon>
    <mat-icon (click)="downloadFile()" class="downlad-icon" *ngIf="fileSelected && downloadFilePreview" matTooltip="Descargar" matTooltipPosition="below" style="z-index: 15;">system_update_alt</mat-icon>
    <mat-icon (click)="deleteFile()" class="delete-icon" *ngIf="fileSelected && !isReadOnly" matTooltip="Eliminar" matTooltipPosition="below" style="z-index: 15;">close</mat-icon>
  </div>
  <mat-card
    appDragAndDrop2
    (filesDropped)="onDropFile($event)"
    [ngClass]="fileSelected ? (!isImageFile ? 'drop-area card-general stl-no-padding' : 'drop-area card-general') : 'p-4 drop-area card-general'"
    (click)="!fileSelected && !isReadOnly && openFileBrowser()"
    >
    <div [formGroup]="parentForm" [hidden]="isFileSelected || fileSelected" class="file-upload-container">
      <mat-icon style="transform: scale(1.4);">save_alt</mat-icon>
      <p>{{text}}</p>
      <input type="file" #fileInput [required]="isRequired" (change)="changeFileListener($event)" class="cdk-visually-hidden" [accept]="accept">
    </div>
    <div class="mx-auto h-100 d-flex justify-content-center align-items-center" *ngIf="isFileSelected && !fileSelected" style="width: fit-content;">
      <app-loading></app-loading>
    </div>
    <mat-card-container *ngIf="fileSelected" style="display:flex; flex-direction:column; width:100%; height:100%;">
      <!-- El visor se elige por el ARCHIVO, no por cómo lo declaró la pantalla.
           Antes una foto subida donde se esperaban documentos salía como ícono
           genérico, y un PDF subido donde se esperaban imágenes salía roto. -->
      <iframe *ngIf="isPdfFile && pdfPreviewUrl" [src]="pdfPreviewUrl" class="pdf-preview" title="{{fileSelected.name}}"></iframe>

      <div class="pdf-placeholder" *ngIf="isPdfFile && !pdfPreviewUrl">
        <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
        <span class="pdf-label">Archivo guardado</span>
        <mat-icon class="pdf-check">check_circle</mat-icon>
      </div>

      <app-stl-viewer *ngIf="isStlFile" [url]="fileSelected.url" style="display:block; width:100%; height:100%;"></app-stl-viewer>

      <div class="pdf-placeholder" *ngIf="isZipFile">
        <mat-icon class="pdf-icon">folder_zip</mat-icon>
        <span class="pdf-label">Archivo guardado</span>
        <mat-icon class="pdf-check">check_circle</mat-icon>
      </div>

      <img mat-card-image src="{{fileSelected.url}}" *ngIf="isImageFile" alt="{{fileSelected.name}}" class="img-fluid w-auto h-100 mx-auto">

      <div class="pdf-placeholder" *ngIf="!isPdfFile && !isStlFile && !isZipFile && !isImageFile">
        <mat-icon class="pdf-icon">insert_drive_file</mat-icon>
        <span class="pdf-label">Archivo guardado</span>
        <mat-icon class="pdf-check">check_circle</mat-icon>
      </div>
    </mat-card-container>

  </mat-card>

  <p class="text-center" [ngClass]="{'p-w-elipsis': textWElipsis}" [matTooltip]="textWElipsis ? fileTitle : ''" style="color: var(--dark-color);">{{fileTitle}}<span *ngIf="isRequired" style="color: #dc3545; font-weight: 700;">*</span></p>
  <p *ngIf="fileSelected && (isGenericFileType || !isImageFile)" class="text-center stl-label-filename" [matTooltip]="getFileNameFromUrl(fileSelected.url, fileSelected.name)">
    <mat-icon style="font-size:13px; width:13px; height:13px; vertical-align:middle;">task</mat-icon>
    {{getFileNameFromUrl(fileSelected.url, fileSelected.name)}}
  </p>
</div>
